import { create } from 'zustand';
import { UserGroup } from '../../../data-access/gql-types/graphql';
import * as storage from '../storage';
import { setCacheData } from '../storage/cache';
import { UserGroupsCollectionSegmentPick } from '../types';

type GroupsStore = {
  groups: UserGroup[];
  groupsLoading: boolean;
  setGroupsLoading: (loading: boolean) => void;
  setGroups: (groups: UserGroupsCollectionSegmentPick, saveInStorage?: boolean) => void;
  clearGroups: () => void;
  isListView: boolean;
  toggleListView: () => void;
  shouldRefetchGroups: boolean;
  refetchGroups: () => void;
  resetRefetchGroups: () => void;
};

export const useGroupsStore = create<GroupsStore>()((set) => ({
  groups: [],
  groupsLoading: false,
  setGroupsLoading: (loading: boolean) => set(() => ({ groupsLoading: loading })),
  setGroups: (groups: UserGroupsCollectionSegmentPick, saveInStorage?: boolean) => {
    const installationId = groups.cacheInfo?.installationId;

    if (installationId && saveInStorage) {
      setCacheData({ kind: 'installation', installationId, perInstallationData: { groups } });
    }

    set(() => ({ groups: groups.items || [] }));
  },
  isListView: storage.getItem('isListView'),
  toggleListView: () => {
    set((state) => {
      const newIsListView = !state.isListView;

      storage.setItem('isListView', newIsListView);
      return { isListView: newIsListView };
    });
  },
  shouldRefetchGroups: false,
  refetchGroups: () => set(() => ({ shouldRefetchGroups: true })),
  resetRefetchGroups: () => set(() => ({ shouldRefetchGroups: false })),
  clearGroups: () => set(() => ({ groups: [] })),
}));
